import { Component } from 'react';
import { List, Map as ImmutableMap, Set as ImmutableSet } from 'immutable';
import I18n from 'I18n';
import MABExperimentModalControlsFields from './MABExperimentModalControlsFields';
import { jsx as _jsx } from "react/jsx-runtime";
const langKey = key => `mab.${key}`;
const MAX_VARIATIONS = 5;
const SUBMISSIONS = 'submissions';
export default class MABExperimentModalControls extends Component {
  constructor(props) {
    super(props);
    this.handleAddVariation = () => {
      const {
        masterContentName
      } = this.props;
      const {
        variations
      } = this.state;
      const newSize = variations.size;
      this.setState({
        variations: variations.push(this.createMABVariationMap(I18n.text(langKey(`newVariation.${newSize}`), {
          masterVariationName: I18n.SafeString(masterContentName || '')
        })))
      });
    };
    this.handleDeleteVariation = index => {
      const {
        variations
      } = this.state;
      this.setState({
        variations: variations.delete(index)
      });
    };
    this.handleDeleteVariationEditMode = index => {
      const {
        existingVariants
      } = this.props;
      const {
        variations
      } = this.state;
      if (existingVariants && index >= existingVariants.size) {
        this.handleDeleteVariation(index);
        return;
      }
      this.setState({
        variations: variations.update(index, variation => variation.set('deleted', true))
      });
    };
    this.handleDeleteVariationEditModeUndo = index => {
      const {
        variations
      } = this.state;
      const updatedVariations = variations.update(index, variation => variation.set('deleted', false));
      const currentVariationCount = updatedVariations.filter(variation => !variation.get('deleted')).size;
      this.setState({
        variations: currentVariationCount > MAX_VARIATIONS - 1 ? updatedVariations.pop() : updatedVariations
      });
    };
    this.handleMasterVariationNameChange = event => {
      const masterVariationName = event.target.value;
      this.setState({
        masterVariationName
      });
    };
    this.handleVariationNameChange = (index, event) => {
      const variationName = event.target.value;
      const {
        variations
      } = this.state;
      this.setState({
        variations: variations.update(index, variation => variation.set('name', variationName))
      });
    };
    this.validateVariationNames = () => {
      const {
        masterVariationName,
        variations
      } = this.state;
      let variationNames = ImmutableSet();
      this.setState({
        variations: variations.map(variation => {
          const name = variation.get('name');
          if (variation.get('deleted')) {
            return variation.set('error', '');
          }
          if (!name) {
            return variation.set('error', 'hasEmptyName');
          }
          const upperCaseName = name.toUpperCase();
          if (upperCaseName !== masterVariationName.toUpperCase() && !variationNames.includes(upperCaseName)) {
            variationNames = variationNames.add(upperCaseName);
            return variation.set('error', '');
          }
          return variation.set('error', 'hasDuplicateName');
        })
      });
    };
    const {
      existingVariants: _existingVariants,
      isEditMode,
      masterContentName: _masterContentName
    } = props;
    const _variations = isEditMode ? _existingVariants === null || _existingVariants === void 0 ? void 0 : _existingVariants.map(variant => ImmutableMap({
      deleted: false,
      error: '',
      id: variant.get('id'),
      name: variant.get('name')
    })) : List.of(ImmutableMap({
      error: '',
      name: I18n.text(langKey('newVariation.0'), {
        masterVariationName: I18n.SafeString(_masterContentName || '')
      })
    }));
    this.state = {
      masterVariationName: _masterContentName || '',
      variations: _variations
    };
  }
  componentDidMount() {
    const {
      masterVariationName,
      variations
    } = this.state;
    const {
      isEditMode,
      onOptionsChange
    } = this.props;
    if (isEditMode) {
      return;
    }
    const mabOptions = ImmutableMap({
      isValid: true,
      metric: SUBMISSIONS,
      masterVariationName,
      newVariantNames: variations.map(variation => variation.get('name'))
    });
    onOptionsChange(mabOptions);
  }
  componentDidUpdate(_prevProps, prevState) {
    const {
      masterVariationName,
      variations
    } = this.state;
    const {
      isEditMode
    } = this.props;
    if (masterVariationName !== prevState.masterVariationName || !variations.equals(prevState.variations)) {
      this.validateVariationNames();
      return;
    }
    const isValid = !!masterVariationName && variations.every(variation => variation.get('error').length === 0);
    let mabOptions = ImmutableMap({
      isValid,
      metric: SUBMISSIONS,
      masterVariationName
    });
    if (isEditMode) {
      mabOptions = mabOptions.set('deletedVariations', variations.filter(variation => Boolean(variation.get('deleted'))));
      mabOptions = mabOptions.set('updatedVariations', variations.filter(variation => Boolean(variation.get('id')) && !variation.get('deleted')).filter((variation, index) => {
        var _this$props$existingV;
        return variation.get('name') !== ((_this$props$existingV = this.props.existingVariants) === null || _this$props$existingV === void 0 || (_this$props$existingV = _this$props$existingV.get(index)) === null || _this$props$existingV === void 0 ? void 0 : _this$props$existingV.get('name'));
      }));
    }
    mabOptions = mabOptions.set('newVariantNames', variations.filter(variation => !variation.get('id')).map(variation => variation.get('name')));
    this.props.onOptionsChange(mabOptions);
  }
  createMABVariationMap(name) {
    return ImmutableMap({
      error: '',
      name
    });
  }
  render() {
    const {
      masterVariationName,
      variations
    } = this.state;
    const {
      isEditMode,
      mabExperimentIsStarted
    } = this.props;
    return /*#__PURE__*/_jsx(MABExperimentModalControlsFields, {
      masterVariationName: masterVariationName,
      maxVariations: MAX_VARIATIONS,
      onAddVariation: this.handleAddVariation,
      onDeleteVariation: isEditMode ? this.handleDeleteVariationEditMode : this.handleDeleteVariation,
      onDeleteVariationUndo: this.handleDeleteVariationEditModeUndo,
      onMasterVariationNameChange: this.handleMasterVariationNameChange,
      onVariationNameChange: this.handleVariationNameChange,
      variations: variations,
      mabExperimentIsStarted: mabExperimentIsStarted
    });
  }
}